/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { RozsahResponse } from '../types/Rozsah';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type SubjektyGetRozsahyEditaceDtiRetrieveRequest = {} | null | undefined;
export type SubjektyGetRozsahyEditaceDtiRetrieveResponse = RozsahResponse;

export type SubjektyGetRozsahyEditaceDtiRetrieveQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this subjekt.
   * required: true
   * ```
   */
  id?: number;

  /**
   * ```yaml
   * in: query
   * name: search
   * schema:
   *   type: string
   * description: Filtruje rozsahy podle id_rozsahu nebo nazev.
   * ```
   */
  search?: string;
};

/**
 * GET /dmx-server/subjekty/{id}/get_rozsahy_editace_dti/
 *
 * ```yaml
 * operationId: subjekty_get_rozsahy_editace_dti_retrieve
 * description: |-
 *   Stáhne z ČUZK aktuální rozsahy k danému subjektu. Rozsahy jsou staženy
 *           včetně subjektů. U subjektů se zobrazí pouze typy_subjektu platné v rámci tohoto rozsahu
 * tags:
 *   - subjekty
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/Rozsah'
 *     description: ''
 * ```
 */
export const subjektyGetRozsahyEditaceDtiRetrieveOperation = ({
  id,
  ...rest
}: SubjektyGetRozsahyEditaceDtiRetrieveQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/subjekty/${id}/get_rozsahy_editace_dti/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/subjekty/{id}/get_rozsahy_editace_dti/' };
  };

/**
 * GET /dmx-server/subjekty/{id}/get_rozsahy_editace_dti/
 *
 * ```yaml
 * operationId: subjekty_get_rozsahy_editace_dti_retrieve
 * description: |-
 *   Stáhne z ČUZK aktuální rozsahy k danému subjektu. Rozsahy jsou staženy
 *           včetně subjektů. U subjektů se zobrazí pouze typy_subjektu platné v rámci tohoto rozsahu
 * tags:
 *   - subjekty
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/Rozsah'
 *     description: ''
 * ```
 */
export const subjektyGetRozsahyEditaceDtiRetrieve = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: SubjektyGetRozsahyEditaceDtiRetrieveQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<RozsahResponse>> => {
  const operation = subjektyGetRozsahyEditaceDtiRetrieveOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/subjekty/{id}/get_rozsahy_editace_dti/
 */
export const useSubjektyGetRozsahyEditaceDtiRetrieveResource = (
  query: SubjektyGetRozsahyEditaceDtiRetrieveQuery | null,
  useCached?: boolean,
): UseResource<SubjektyGetRozsahyEditaceDtiRetrieveResponse> => {
  return useResource<SubjektyGetRozsahyEditaceDtiRetrieveResponse>({
    path: query === null ? null : subjektyGetRozsahyEditaceDtiRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
